export default __webpack_public_path__ + "static/media/basket.14d64820.svg";